import { Button } from '@cibli/shared';
import { FileText, Video } from 'lucide-react';
import { useEffect, useState } from 'react';
import { useTranslation } from 'react-i18next';
import { useNavigate, useParams } from 'react-router';

interface StoredJob {
  id: string;
  title: string;
  position?: string;
  workLocationCity?: string | null;
}

export default function ApplyLandingPage() {
  const { jobId } = useParams<{ jobId: string }>();
  const navigate = useNavigate();
  const { t } = useTranslation();
  const [job, setJob] = useState<StoredJob | null>(null);

  useEffect(() => {
    if (!jobId) return;
    const raw = sessionStorage.getItem(`cibli_job_${jobId}`);
    if (raw) {
      try {
        setJob(JSON.parse(raw) as StoredJob);
      } catch {
        // ignore parse errors
      }
    }
  }, [jobId]);

  return (
    <div className="min-h-screen flex items-center justify-center bg-background px-4">
      <div className="w-full max-w-lg space-y-8">
        <div className="text-center space-y-2">
          <h1 className="text-2xl font-semibold">
            {job?.title ?? t('apply.landing.title', 'Candidater')}
          </h1>
          {job?.workLocationCity && (
            <p className="text-muted-foreground text-sm">{job.workLocationCity}</p>
          )}
          <p className="text-muted-foreground">
            {t('apply.landing.subtitle', 'Comment souhaitez-vous postuler ?')}
          </p>
        </div>

        <div className="grid gap-4">
          <button
            onClick={() => navigate(`/apply/${jobId}/upload`)}
            className="flex items-start gap-4 rounded-xl border bg-card p-5 text-left hover:bg-accent transition-colors"
          >
            <FileText className="size-6 mt-0.5 shrink-0 text-primary" />
            <div>
              <p className="font-medium">{t('apply.landing.uploadCv', 'Déposer mon CV')}</p>
              <p className="text-sm text-muted-foreground mt-0.5">
                {t('apply.landing.uploadCvDesc', 'Importez votre CV au format PDF ou Word')}
              </p>
            </div>
          </button>

          <button
            onClick={() => navigate(`/apply/${jobId}/interview`)}
            className="flex items-start gap-4 rounded-xl border bg-card p-5 text-left hover:bg-accent transition-colors"
          >
            <Video className="size-6 mt-0.5 shrink-0 text-primary" />
            <div>
              <p className="font-medium">{t('apply.landing.interview', "Commencer l'entretien")}</p>
              <p className="text-sm text-muted-foreground mt-0.5">
                {t('apply.landing.interviewDesc', 'Répondez à quelques questions en vidéo')}
              </p>
            </div>
          </button>
        </div>

        <div className="text-center">
          <Button variant="ghost" size="sm" onClick={() => navigate('/')}>
            {t('apply.landing.back', "Retour à l'accueil")}
          </Button>
        </div>
      </div>
    </div>
  );
}
